import Reveal from "@/components/Reveal";

export default function PageHero({ overline, title, subtitle, image, testId = "page-hero" }) {
  return (
    <section data-testid={testId} className="relative pt-32 md:pt-40 pb-20 md:pb-28 border-b border-white/10 overflow-hidden">
      {image && (
        <div className="absolute inset-0 -z-10">
          <img src={image} alt="" className="w-full h-full object-cover bw-img opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black" />
        </div>
      )}
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-9">
          <Reveal>
            <p className="overline text-white/55">{overline}</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h1 className="font-serif font-light text-white text-5xl sm:text-6xl md:text-7xl leading-[1.02] tracking-tight mt-6">
              {title}
            </h1>
          </Reveal>
          {subtitle && (
            <Reveal delay={0.16}>
              <p className="font-sans font-light text-white/75 text-base md:text-lg mt-8 max-w-2xl leading-relaxed">
                {subtitle}
              </p>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}
